// Configuration utility class
class Config {
  getEnvValue(key, defaultValue) {
    const value = window._env_?.[key];
    console.log(`Config: ${key} = ${value || 'undefined'}`);
    if (value) {
      return value;
    }
    if (defaultValue) {
      return defaultValue;
    }
    throw new Error(`Configuration value for ${key} is not defined. Please check your config file.`);
  }

  get apiBaseUrl() {
    return this.getEnvValue('REACT_APP_API_BASE_URL');
  }

  get loginUrl() {
    return this.getEnvValue('REACT_APP_LOGIN_URL');
  }

  get logoutUrl() {
    return this.getEnvValue('REACT_APP_LOGOUT_URL');
  }

  get applicationUrl() {
    return this.getEnvValue('REACT_APP_APPLICATION_URL');
  }

  get frontendUrl() {
    return this.getEnvValue('REACT_APP_FRONTEND_URL');
  }

  get momAzureTenantId() {
    return this.getEnvValue('REACT_APP_MOM_AZURE_TENANT_ID');
  }

  get momAzureClientId() {
    return this.getEnvValue('REACT_APP_MOM_AZURE_CLIENT_ID');
  }
}

// Export a singleton instance
export const config = new Config();


